<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <div class="padding-ten-tb no-printme">
      <b-row>
        <b-col xs="12" sm="6" md="6" lg="6">
          <b-button class="btn-grey" @click="goBack">
            Orden de Servicio
          </b-button>
        </b-col>
        <b-col xs="12" sm="6" md="6" lg="6">
          <b-breadcrumb :items="items"></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4" style="text-align: left; padding-right: 0">
          <!--<b-button @click="sendEmail" class="bg-grey-btn">
            <font-awesome-icon icon="paper-plane" /> Enviar</b-button
          > -->
          <b-button
            class="bg-orange-btn padding-two-left"
            v-on:click="printPartOfPage"
          >
            <font-awesome-icon icon="print" /> Imprimir</b-button
          >
        </b-col>
      </b-row>
    </div>

    <div class="bg-white padding-five-all printme">
      <b-container fluid>
        <b-row class="padding-fifteen-all">
          <b-col cols="4">
            <img
              src="../../assets/logo-promart.png"
              style="height: 80px; width: auto"
              alt=""
            />
          </b-col>
          <b-col cols="4" class="p-align-center">
            <p class="font-weight-500" style="margin-bottom: 0">
              ORDEN DE SERVICIO
            </p>
          </b-col>
          <b-col cols="4" class="p-align-center">
            <p class="font-weight-500" style="margin-bottom: 0">
              N°:{{ $route.params.id }}
            </p>
          </b-col>
        </b-row>
        <div class="bg-grey">
          <b-row>
            <b-col cols="12">
              <h6 class="text-orange padding-three-top">Datos generales</h6>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="padding-two-bottom">
              <label class="text-grey">Usuario:</label>
              <span>
                {{ this.infoPrintOs.user }}
              </span>
            </b-col>
            <b-col cols="4" class="padding-two-bottom">
              <label class="text-grey">Tienda:</label>
              <span>
                {{ this.infoPrintOs.store }}
              </span>
            </b-col>
            <b-col cols="4" class="padding-two-bottom">
              <label class="text-grey">Fecha Creación OS:</label>
              <span>
                {{formatDate(infoPrintOs.creationDate)}}
              </span>
            </b-col>
          </b-row>
        </div>
        <div class="bg-grey">
          <b-row>
            <b-col cols="12">
              <h6 class="text-orange padding-three-top">Datos del cliente</h6>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="padding-two-bottom">
              <label class="text-grey">Nombre completo</label>
              <span>
                {{ infoPrintOs.name }}
              </span>
            </b-col>
            <b-col cols="4" class="padding-two-bottom">
              <label class="text-grey">Doc. Identidad</label>
              <span>
                {{ infoPrintOs.identityDocument }}
              </span>
            </b-col>
            <b-col cols="4" class="padding-two-bottom">
              <label class="text-grey">Teléfono</label>
              <span>
                {{ this.infoPrintOs.phone }}
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="padding-two-bottom">
              <label class="text-grey">Correo Electrónico</label>
              <span>
                {{ this.infoPrintOs.mail }}
              </span>
            </b-col>
            <b-col cols="4" class="padding-two-bottom">
              <label class="text-grey">Departamento</label>
              <span>
                {{ infoPrintOs.department }}
              </span>
            </b-col>
            <b-col cols="4" class="padding-two-bottom">
              <label class="text-grey">Provincia</label>
              <span>
                {{ infoPrintOs.province }}
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="padding-two-bottom">
              <label class="text-grey">Distrito</label>
              <span>
                {{ infoPrintOs.district }}
              </span>
            </b-col>
            <b-col cols="4" class="padding-two-bottom">
              <label class="text-grey">Dirección</label>
              <span>
                {{ infoPrintOs.direction }}
              </span>
            </b-col>
            <b-col cols="4" class="padding-two-bottom">
              <label class="text-grey">Referencia</label>
              <span>
                {{ infoPrintOs.reference }}
              </span>
            </b-col>
          </b-row>
        </div>
        <div class="bg-grey">
          <b-row>
            <b-col cols="12">
              <h6 class="text-orange padding-three-top">Datos del servicio</h6>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" >
              <div
                v-for="listProduct in infoPrintOs.children"
                :key="listProduct.id"
                class="padding-twenty-five-bottom"
              >
                <b-row>
                  <b-col cols="12">
                    <p class="text-bold">N° Orden de Servicio: {{ listProduct.sequence }}</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4" class="padding-two-bottom">
                    <label class="text-grey">SKU servicio</label>
                    <span>
                      {{
                        listProduct.serviceSku +
                        "-" +
                        listProduct.serviceDescription
                      }}
                    </span>
                  </b-col>
                  <b-col cols="4" class="padding-two-bottom">
                    <label class="text-grey">SKU producto</label>
                    <span>
                      {{
                        listProduct.referenceSku +
                        "-" +
                        listProduct.referenceDescription
                      }}
                    </span>
                  </b-col>
                  <b-col cols="4" class="padding-two-bottom">
                    <label class="text-grey">Cantidad</label>
                    <span>
                      {{ listProduct.quantity }}
                    </span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4" class="padding-two-bottom">
                    <label class="text-grey">Fecha Estimada del servicio</label>
                    <span>
                      {{ listProduct.estimatedDate }}
                    </span>
                  </b-col>
                  <b-col cols="4" class="padding-two-bottom">
                    <label class="text-grey">Turno</label>
                    <span>
                      {{ listProduct.turn }}
                    </span>
                  </b-col>
                  <b-col cols="4" class="padding-two-bottom">
                    <label class="text-grey">Nombre del proveedor</label>
                    <span class="text-bold">
                      {{ listProduct.provider }}
                    </span>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col cols="12">
            <div class="border-bottom-grey">
              <label class="text-grey margin-bottom-two">
                Observaciones del cliente
              </label>
              <p>{{ infoPrintOs.clientObservation }}</p>
            </div>
          </b-col>
        </b-row>
        <b-row class="padding-two-top">
          <b-col cols="12">
            <template v-if="infoPrintOs.children[0].type=='OWNED'">
            <p style="font-style: italic; font-size: 0.9rem">
              - En caso no te encuentres en tu domicilio en la fecha programada
              para el servicio, deberás acercarte a tienda a pagar una
              reprogramación para poder agendarte una nueva fecha
            </p>
            <p style="font-style: italic; font-size: 0.9rem">
              -En caso no realices la reprogramación de tu servicio en un plazo
              de 30 días calendario, tendrás que pagar un nuevo servicio.
            </p>
            </template>
            <template v-else-if="infoPrintOs.children[0].type=='THIRD_PARTY'">
           
            <p style="font-style: italic; font-size: 0.9rem">
              - Recuerda que el proveedor de la marca se comunicará contigo para
              coordinar la fecha y turno de atención de tu instalación.
            </p>
             </template>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "PrintDetailOs",
  data() {
    return {
      items: [
        {
          text: "Admin. OS",
          to: { name: "AdministracionOs" },
        },
        {
          text: "Impresión OS",
        },
      ],
      selectMode: "multi",
      fields: [
        { key: "selected", label: "" },
        { key: "option", label: "" },
      ],
      selected: [],
      infoPrintOs: {
        children: [
          {
            clientObservation: "",
            serviceSku: "",
            referenceSku: "",
            referenceDescription: "",
            serviceDescription: "",
            type:""
          },
        ],
        mails: [],
        phones: [],
        directions: [],
        lastName: "",
        motherLastName: "",
        names: "",
      },
    };
  },
  computed:{
    ...mapState("module", [
      "token"
    ])
  },
  created() {
    this.printOs();
  },
  methods: {
    formatDate(date){
      return moment(date).format('MM/DD/YYYY');   
    },
    translateTurn(value) {
      switch (value) {
        case "MORNING":
          return "MAÑANA";
        case "AFTERNOON":
          return "TARDE";
        case "ALL_DAY":
          return "DURANTE EL DÍA";
        default:
          return "-";
      }
    },
    async printOs() {
      try {
        this.$store.commit("SET_LOADING", true);
        const fetchedId = this.$route.params.id;
        if (this.$route.params.id !== fetchedId) return;
        let response = await axios.get(
          process.env.VUE_APP_RECORDS_BUSINESS_BASE +
            "/parent-summary/" +
            this.$route.params.id,
            {
              headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer "+ this.token
              },
            }
        );
        console.log(response);

        this.infoPrintOs = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    printPartOfPage() {
      window.print();
    },
    /* printPartOfPage() {

      let content = document.getElementById("ifmcontentstoprint");
      let pri = document.getElementById("ifmcontentstoprint")
        .contentWindow.window.open();
      pri.document.open();
      pri.document.write(content.innerHTML);
      pri.document.close();
      pri.focus();
      pri.print();
    },
 */
    async sendEmail() {
      try {
        this.$store.commit("SET_LOADING", true);
        const params = JSON.stringify({ ruta: "hi" });
        const data = {
          externalTemplateId: 0,
          externalUrl: "http://10.20.12.134:31619/Template/175",
          to: this.infoPrintOs.mails[0].contact,
          reclamoTipo: "notificacionGerente",
          parameters: params,
        };
        let response = await axios.post(
          "http://10.20.12.134:32052/externalemails/send",
          data,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        let values = { variant: "success", msg: "Se envío exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        console.log(response);
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }
    },
  },
};
</script>
<style scoped>
.bg-grey-btn {
  background-color: #676767;
  border-radius: 20px;
}

.padding-two-left {
  margin-left: 25px;
}
::v-deep.breadcrumb {
  background: transparent !important;
  justify-content: flex-end !important;
  color: #676767;
  font-weight: bold;
}
a:hover {
  color: rgb(254, 123, 1) !important;
}
a {
  color: #676767 !important;
}
.p-align-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.margin-bottom-two {
  margin-bottom: 0.5rem;
}
.border-bottom-grey {
  border-bottom: 1px solid #ced4da;
  padding-bottom: 6px;
}
@media print and (width: 21cm) and (height: 29.7cm) {
  @page {
    margin: 100cm;
  }
}
@media print {
  .no-printme {
    display: none;
  }
  .printme {
    display: block;
    size: 25cm 35.7cm;
    margin: 5mm 5mm 5mm 5mm;
  }
}
@page {
  size: A4 landscape;
  margin: 50%;
}
table {
  border-collapse: collapse;
}
table tbody {
  border-top: 20px solid white;
}
.padding-fifteen-all {
  padding: 15px;
}
.btn-grey {
  background: transparent !important;
  color: #676767 !important;
  border-color: transparent !important;
  font-weight: bold;
}
.padding-ten-lr {
  padding-left: 51px;
  padding-right: 51px;
  margin-bottom: 25px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.bg-grey {
  background-color: #f4f4f4;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 15px;
  border-radius: 7px;
}
::v-deep .modal-title {
  font-size: 17px !important;
}
.text-center {
  text-align: center;
}
.padding-two-bottom {
  padding-bottom: 4px;
}
::v-deep .b-table thead {
  background: rgb(254, 123, 1);
  color: white;
  font-weight: 400 !important;
}
.border-tb {
  border-bottom: 10px solid black;
}
::v-deep .b-table thead th {
  font-weight: 400 !important;
}
.padding-two-top {
  padding-top: 3%;
}
.padding-three-top {
  padding-top: 5px;
}
.border-gray {
  border: 1px solid #ababab;
}
.padding-right-none {
  padding-right: 0 !important;
}
.padding-left-none {
  padding-left: 0 !important;
}
.bg-orange {
  background: rgb(254, 123, 1) !important;
}
.text-orange {
  color: #ff7a00;
}

.font-weight-500 {
  font-weight: 700;
}
.text-bold{
  font-weight: 700;
}
.padding-twenty-five-bottom{
  padding-bottom: 25px;
}
</style>
